/** A small set of mutually exclusive choices shown all at once (radio semantics). */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  label: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} className="flex w-full gap-0.5 rounded-[10px] bg-search p-[3px]">
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            className={`h-[38px] flex-1 rounded-[8px] px-3 text-[14.5px] transition-colors duration-[180ms] ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${
              selected ? 'bg-elev font-semibold text-ink shadow-[0_1px_2px_rgba(15,21,24,0.12)]' : 'font-medium text-ink2 hover:text-ink'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
